import {
  TABLE_ADMIN_AI_IMAGE_MODEL_BUTTON,
  TABLE_ADMIN_AI_IMAGE_PROVIDER_GOOGLE,
  TABLE_ADMIN_AI_IMAGE_PROVIDER_OPENAI,
  TABLE_ADMIN_AI_IMAGE_PROVIDER_SEEDREAM,
} from "../../i18n/keysTranslations";

export const AGENCY_IMAGE_PROVIDERS = Object.freeze({
  GOOGLE: "google",
  OPENAI: "openai",
  SEEDREAM: "seedream",
});

export const DEFAULT_AGENCY_IMAGE_PROVIDER = AGENCY_IMAGE_PROVIDERS.GOOGLE;

const AGENCY_IMAGE_PROVIDER_VALUES = Object.values(AGENCY_IMAGE_PROVIDERS);

export const AGENCY_IMAGE_PROVIDER_OPTIONS = [
  {
    value: AGENCY_IMAGE_PROVIDERS.GOOGLE,
    labelKey: TABLE_ADMIN_AI_IMAGE_PROVIDER_GOOGLE,
  },
  {
    value: AGENCY_IMAGE_PROVIDERS.OPENAI,
    labelKey: TABLE_ADMIN_AI_IMAGE_PROVIDER_OPENAI,
  },
  {
    value: AGENCY_IMAGE_PROVIDERS.SEEDREAM,
    labelKey: TABLE_ADMIN_AI_IMAGE_PROVIDER_SEEDREAM,
  },
];

export const isValidAgencyImageProvider = (value) =>
  AGENCY_IMAGE_PROVIDER_VALUES.includes(value);

export const resolveAgencyImageProvider = (value) =>
  isValidAgencyImageProvider(value) ? value : DEFAULT_AGENCY_IMAGE_PROVIDER;

export const getAgencyImageProviderMenuOption = ({
  agencyID,
  selectedProvider,
  onSelect,
  updating = null,
}) => {
  if (!agencyID) {
    return null;
  }

  const normalizedSelected = resolveAgencyImageProvider(selectedProvider);
  const isUpdatingTarget =
    Boolean(updating) && (updating.agencyID || "") === (agencyID || "");

  return {
    label: TABLE_ADMIN_AI_IMAGE_MODEL_BUTTON,
    submenu: AGENCY_IMAGE_PROVIDER_OPTIONS.map((option) => ({
      key: option.value,
      value: option.value,
      label: option.labelKey,
      type: "radio",
      checked: normalizedSelected === option.value,
      loading: isUpdatingTarget && updating.provider === option.value,
      disabled: Boolean(updating),
      onChange: (imageProvider) =>
        onSelect({
          agencyID,
          imageProvider,
        }),
    })),
  };
};
